export const HOME = '/'

export const AUTH = '/auth'
export const LOGIN = AUTH + '/login'
export const PORTAL_LOGIN = AUTH + '/portal-login'

export const COMPANY_LIST = '/company-list'

// In-app notifications (served by portal-service, public.notifications scoped to ERPBOI_LABOR).
// Reached from the topbar bell, not the sidebar, and not feature-gated: the feed is the caller's own.
export const NOTIFICATIONS = '/notifications'

// Where "/" and a denied route land. Not a page of its own: it forwards to Labor Information when
// the user holds it, else to the first screen the sidebar grants (pages/landing/Landing). It must
// NOT be a feature-guarded route — RequireFeature redirects here, so a guarded landing page would
// bounce a user without that feature back and forth.
export const LANDING = '/home'

//labor welfare — workers: a separate record from employees (own tables, APIs and masters), no
// self-service. These urls are the permission keys stored in auth.features.url — do not rename.
// They kept the /labor-welfare prefix when the screens moved out of hrm into this console: the
// ACL does not scope urls by app, so a prefix unique to this module keeps them from colliding
// with another console's routes.
export const LABOR_WELFARE = '/labor-welfare'
export const WORKER = LABOR_WELFARE + '/worker'
export const WORKER_ADD = LABOR_WELFARE + '/worker/add'
export const WORKER_EDIT: (p: {id: string}) => string = ({id}) => `${LABOR_WELFARE}/worker/edit/${id}`
export const WORKER_VIEW: (p: {id: string}) => string = ({id}) => `${LABOR_WELFARE}/worker/view/${id}`
export const WORKER_PAYROLL = LABOR_WELFARE + '/worker-payroll'
export const WRK_CATEGORY = LABOR_WELFARE + '/category'
export const WRK_DESIGNATION = LABOR_WELFARE + '/designation'
export const WRK_GRADE = LABOR_WELFARE + '/grade'
// Company worker-code format (AUTO/MANUAL, prefix, digits). The url is the permission key.
export const WRK_CODE_CONFIG = LABOR_WELFARE + '/worker-code'
export const WRK_WORK_TYPE = LABOR_WELFARE + '/work-type'
export const WRK_LABOR_TYPE = LABOR_WELFARE + '/labor-type'
export const WRK_MAJOR_PRODUCT = LABOR_WELFARE + '/major-product'
export const WRK_MACHINE = LABOR_WELFARE + '/machine'
// Leave & Attn — HRM's Leave & Attn screens copied for workers. HR files everything on the
// worker's behalf (workers have no login); employees approve it under Approvals below. Same
// prefix rule as above.
export const WRK_LEAVE_TYPE = LABOR_WELFARE + '/leave-type'
export const WRK_LEAVE_FOR_WORKER = LABOR_WELFARE + '/leave-for-worker'
export const WRK_ATTENDANCE_FOR_WORKER = LABOR_WELFARE + '/attendance-for-worker'
export const WRK_WORKER_ATTENDANCE = LABOR_WELFARE + '/worker-attendance'
// Worker Leave — the company-wide leave register, the leave counterpart of Worker Attendance
// (hrm's Employee Leave for workers). Same prefix rule as above.
export const WRK_WORKER_LEAVE = LABOR_WELFARE + '/worker-leave'
// Approvals — one list of what HR filed (My Requests) and one queue where EMPLOYEES approve worker
// leave / manual attendance (Pending Approvals), like store's and HRM's (labor-service's engine, doc
// types WRK_LEAVE / WRK_ATTENDANCE). Pending Approvals is the one screen a self-service employee may
// open here. Setup -> Approval Workflow configures who approves. Same prefix rule as above.
export const LW_MY_REQUESTS = LABOR_WELFARE + '/my-requests'
export const LW_PENDING_APPROVALS = LABOR_WELFARE + '/pending-approvals'
// The retired per-type approval pages: an old bookmark or bell link lands on Pending Approvals.
export const LEGACY_WRK_LEAVE_APPROVAL = LABOR_WELFARE + '/worker-leave-approval'
export const LEGACY_WRK_ATTENDANCE_APPROVAL = LABOR_WELFARE + '/worker-attendance-approval'
export const WRK_APPROVAL_WORKFLOW = LABOR_WELFARE + '/approval-workflow'
// Wages (docs/labor-wages-plan.md): a worker is paid by their work type's pay basis (time or piece),
// daily or weekly. Daily Output records what piece workers produced; its bulk entry page is part of
// the same feature (Create). Piece Rates and Wage Settings sit under Setup. Same prefix rule as above.
export const WRK_DAILY_OUTPUT = LABOR_WELFARE + '/daily-output'
export const WRK_DAILY_OUTPUT_ENTRY = LABOR_WELFARE + '/daily-output/entry'
export const WRK_PIECE_RATE = LABOR_WELFARE + '/piece-rate'
export const WRK_WAGE_SETTINGS = LABOR_WELFARE + '/wage-settings'
// Wage sheets: one per cycle + period (+ location). The sheet's own page rides the same feature.
export const WRK_WAGE_SHEET = LABOR_WELFARE + '/wage-sheet'
export const WRK_WAGE_SHEET_VIEW: (p: {id: string}) => string = ({id}) => `${LABOR_WELFARE}/wage-sheet/${id}`
// Advances: money given ahead of the wage, recovered from the worker's wage sheets.
export const WRK_ADVANCE = LABOR_WELFARE + '/advance'
// Reports (docs/labor-wages-plan.md, Phase 5): read-only, one LBR_RPT_* feature each.
export const WRK_RPT_EARNINGS = LABOR_WELFARE + '/reports/earnings'
export const WRK_RPT_OVERTIME = LABOR_WELFARE + '/reports/overtime'
export const WRK_RPT_PRODUCTION = LABOR_WELFARE + '/reports/production'
export const WRK_RPT_UNPAID = LABOR_WELFARE + '/reports/unpaid-wages'
